<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="" prop="keywords">
                <el-input style="width: 300px;" v-model="query.keywords" placeholder="搜索评论人手机号或ID、评论关键词" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="评论时间" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="评论状态" prop="status">
                <el-select v-model="query.status" placeholder="请选择评论状态">
                    <el-option label="正常" :value="1"></el-option>
                    <el-option label="已下架" :value="2"></el-option>
                </el-select>
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="帖子ID" align="center" prop="id"></el-table-column>
            <el-table-column label="评论用户" align="center" prop="userName"></el-table-column>
            <el-table-column label="评论内容" align="center" prop="content"></el-table-column>
            <el-table-column label="所属帖子" align="center" prop="parentPostTitle"></el-table-column>
            <el-table-column label="评论类型" align="center" prop="commentType">
                <template slot-scope="{ row }">
                    {{ { 1: '一级评论', 2: '二级评论' }[row.commentType] }}
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" prop="status">
                <template slot-scope="{ row }">
                    {{ { 1: '正常', 2: '已下架' }[row.status] }}
                </template>
            </el-table-column>
            <el-table-column label="评论时间" align="center" prop="commentTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140">
                <template slot-scope="{ row }">
                    <template v-if="permission('/community/comment/off')">
                        <el-link :underline="false" type="danger" @click="handleUpdateStatus(row, 2)"
                            v-if="row.status === 1">
                            下架
                        </el-link>
                        <el-link :underline="false" type="success" @click="handleUpdateStatus(row, 1)" v-else> 上架 </el-link>
                    </template>
                    <el-link v-if="permission('/community/comment/delete')" :underline="false" type="danger" @click="handleDelete(row)">
                        删除
                    </el-link>
                    <el-link v-if="permission('/community/comment/detail')" :underline="false" type="primary" @click="handleDetail(row)">
                        详情
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del, edit } from "@/api/community/comment";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                keywords: "",
                pageNo: 1,
                pageSize: 10,
                date: [],
                status: "",
            },
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date && this.query.date[0] ? this.query.date[0] + ' 00:00:00' : '',
                endTime: this.query.date && this.query.date[1] ? this.query.date[1] + ' 23:59:59' : '',
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleUpdateStatus(row, status) {
            edit({ ...row, status }).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success('操作成功');
                    this.search();
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleDelete(row) {
            this.$confirm("确定删除该评论吗？", "提示", { type: "warning" }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                })
            }).catch(() => { });
        },
        handleDetail(row) {
            this.$router.push({ path: "/community/comment/detail", query: { id: row.id } });
        }
    },
};
</script>